/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';
import { Theme, getColor } from 'styles/theme';
import { arrowDown } from 'styles/icons';
import { getHeadingStyle } from 'styles/typography/Heading';
import { font } from 'styles/globals';

export const details = css<{ theme: Theme }>`
  .wp-block-details {
    margin-bottom: 24px;

    & > p {
      padding: 0px;
      font-family: ${font.graphikCond};
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      letter-spacing: 0.5px;
    }

    & > summary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      color: ${getColor('textPrimary')};
      padding: 8px 0;
      border-bottom: 1px solid ${getColor('borderSecondary')};
      letter-spacing: 0.5px;

      &::-webkit-details-marker {
        display:none;
      }

      &, & > h2, & > h3, & > h4, & > h5, & > h6 {
        margin: 0;
      }
 
      & > h2 {
        ${getHeadingStyle({ default: 'level2' }, 'graphikCond')};
      }

      & > h3 {
        ${getHeadingStyle({ default: 'level3' }, 'graphikCond')};
      }

      & > h4 {
        ${getHeadingStyle({ default: 'level4' }, 'graphikCond')};
      }

      & > h5 {
        ${getHeadingStyle({ default: 'level5' }, 'graphikCond')};
      }

      & > h6 {
        ${getHeadingStyle({ default: 'level6' }, 'graphikCond')};
      }

      &::after {
        content: "";
        ${arrowDown}
        border-color: ${getColor('borderBlack')};
        padding: 4px;
      }

      &:hover {
        cursor: pointer;
        &, & > h2, & > h3, & > h4, & > h5, & > h6 {
          color: ${getColor('textAccentPrimary')};
        }        &:after {
          border-color: ${getColor('borderAccentPrimary')};
        }
      }
    }

    & > *:not(summary) {
      margin-top: 0;
      margin-bottom: 24px;
    }

    &[open]{
      & > summary {
        margin-bottom: 16px;
        &, & > h2, & > h3, & > h4, & > h5, & > h6 {
          border-color: ${getColor('borderAccentPrimary')};
        }
        &:after {
          border-color: ${getColor('borderAccentPrimary')};
          transform: rotate(225deg);
        }
      }
    }
  }
`;
